import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules, withComponentInputBinding } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { TokenInterceptor } from '@shared/interceptors/token.interceptor';
import { ErrorInterceptor } from '@shared/interceptors/error.interceptor';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { IonicStorageModule } from '@ionic/storage-angular';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es-AR';
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { LayoutModule } from '@angular/cdk/layout';

registerLocaleData(localeEn, 'en-US');
registerLocaleData(localeEs, 'es-AR');
registerLocaleData(localePt, 'pt-BR');

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),importProvidersFrom([IonicStorageModule.forRoot(), LayoutModule]),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular({
      useSetInputAPI: true,
      mode: 'md',
    }),
    provideAnimations(),
    provideHttpClient(withInterceptors([TokenInterceptor, ErrorInterceptor])),
    provideRouter(routes, withPreloading(PreloadAllModules), withComponentInputBinding()),
  ],
});
